import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=59b3256a&scoped=true&"
import script from "./type2.vue?vue&type=script&lang=js&"
export * from "./type2.vue?vue&type=script&lang=js&"
import style0 from "./type2.vue?vue&type=style&index=0&id=59b3256a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3256a",
  null
  
)

export default component.exports